import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  states: []
}

const mutations = {  
  SET_ESTATES (state, payload) {
    state.states = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }  
}

const actions = {
  statesList: (context, data) => {
    let query = '?'    
    for (let f in data) {       
      if (Array.isArray(data[f])) {
        for (let element of data[f]) {                 
          query += `&${f}[]=${element}`
        }
      } else {          
        query += `&${f}=${data[f]}`
      }
    }
    
    return Vue.http.get(`${env.API}/api/state${query}`)    
      .then((response) => {        
        context.commit('SET_ESTATES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getStates: (state) => state.states
}

export const State = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/state.js